import { ExternalLink } from 'lucide-react';
import { secondaryButtonClass } from './FilterBar';
import { EXTERNAL_LINK_PROPS, getAppLink, getAppLinkByIntegration } from '../lib/appLinks';

interface OpenInAppButtonProps {
  /** App id from appLinks (e.g. "erpnext", "twenty") */
  appId?: string;
  /** Integration key — resolved to app link when appId omitted */
  integrationKey?: string;
  className?: string;
  compact?: boolean;
}

function OpenInAppButton({
  appId,
  integrationKey,
  className,
  compact = false,
}: OpenInAppButtonProps) {
  const link = appId
    ? getAppLink(appId)
    : integrationKey
      ? getAppLinkByIntegration(integrationKey)
      : undefined;

  if (!link) return null;

  return (
    <a
      href={link.url}
      {...EXTERNAL_LINK_PROPS}
      className={className ?? secondaryButtonClass}
      title={`Open ${link.name} in a new tab`}
    >
      <ExternalLink size={compact ? 14 : 16} />
      <span>
        Open in {link.name}
        {!compact && ' →'}
      </span>
    </a>
  );
}

export default OpenInAppButton;
